import Get from '../services/Get';
import Post from '../services/Post';
import Put from '../services/Put';
import Delete from '../services/Delete';

import { nexcareVersion } from '../config/serviceConfig';

const getListRootCauseTicketAll = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket-all/remark/root-cause?page=${page}&limit=${limit}`, token);
const getListPriorityTicketAll = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket-all/remark/priority?page=${page}&limit=${limit}`, token);
const getListUserCSTicketAll = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket-all/user-cs?page=${page}&limit=${limit}&order=alias_name asc`, token);
const getSearchUserCSTicketAll = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/ticket-all/user-cs?page=${page}&limit=${limit}&filter=alias_name like ${filter}&order=alias_name asc`, token);

const getDataTicketInitiateUnassigned = (token) => Get(`/${nexcareVersion}/nexcare/ticket/unassigned/initiate`, token);
const getDataTicketUnassigned = (page, limit, orderBy, token) => Get(`/${nexcareVersion}/nexcare/ticket/unassigned?page=${page}&limit=${limit}&order=${orderBy}`, token);
const getDetailTicketUnassigned = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/unassigned/${id}`, token);

const getDataTicketInitiate = (token) => Get(`/${nexcareVersion}/nexcare/ticket/initiate`, token);
const getDataTicketAll = (page, limit, orderBy, token) => Get(`/${nexcareVersion}/nexcare/ticket?page=${page}&limit=${limit}&order=${orderBy}`, token);
const getDataTicketEmail = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket/assigned?page=${page}&limit=${limit}&filter=tracker eq email`, token);
const getDataTicketPhone = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket/assigned?page=${page}&limit=${limit}&filter=tracker eq phone`, token);
const getDetailDataTicketAllCSO = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/${id}`, token);

const getListCustomerServiceLead = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-cs/get-lead?page=${page}&limit=${limit}`, token);

const putDataOpenTicket = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/open/${id}`, data, token);

const putDataAssignOwn = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/assign-own/${id}`, data, token);
const putDataAssignByLead = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/assign/${id}`, data, token);
const putDataReassignByLead = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/reassign/${id}`, data, token);
const putDataReassignInProgress = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/reassign/in-progress/${id}`, data, token);
const putDataReopenTicket = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/reopen/${id}`, data, token);

const putDataUpdateNote = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/update-note/${id}`, data, token);
const putDataUpdateDescription = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/update-issue-desc/${id}`, data, token);
const putDataUpdateTitle = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/update-issue-title/${id}`, data, token);

const putDataEscalationCsBySystem = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/escalate/auto/${id}`, data, token);
const putDataEscalationCsByUser = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/escalate-ticket/${id}`, data, token);
const putDataEscalationBugExternal = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/escalate-bug-external/${id}`, data, token);
const putDataEscalationBugValidator = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/escalate-bug-validator/${id}`, data, token);
const putDataEscalationLead = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/escalate-cs-lead/${id}`, data, token);

const putDataUrlLink = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/link/${id}`, data, token);
const putDataReleaseVersion = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/release-version/${id}`, data, token);

const putDataRedmine = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/redmine/${id}`, data, token);

const getListComplaint = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket-all/complaint?page=${page}&limit=${limit}`, token);
const getListComplaintCategory = (page, limit, value, token) => Get(`/${nexcareVersion}/nexcare/ticket-all/complaint-category?page=${page}&limit=${limit}&filter=complaint_id eq ${value}`, token);
const getListComplaintSub = (page, limit, value, token) => Get(`/${nexcareVersion}/nexcare/ticket-all/complaint-sub?page=${page}&limit=${limit}&filter=complaint_category_id eq ${value}`, token);

const putDataTicketComplaint = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/complaint/${id}`, data, token);
const putDataTicketRootCause = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/change-rootcause/${id}`, data, token);

const putDataCloseTicketWithPatch = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/close/w-patch/${id}`, data, token);
const putDataCloseTicketWithoutPatch = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/close/wo-patch/${id}`, data, token);
const putDataCloseTicketWithoutSolution = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/close/wo-solution/${id}`, data, token);
const putDataCloseTicketWorkAround = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/close/work-around/${id}`, data, token);
const putDataCloseTicketChangeRequest = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/close/change-request/${id}`, data, token);

// API Sementara
const postDataUploadChat = (data, token) => Post(`/v1/nexcare/grochat/upload/chat`, data, token);
const putOpenChatroom = (data, id, token) => Put(`/v1/nexcare/ticket/chatroom/${id}`, data, token);
const postCloseChatroom = (data, token) => Post(`/v1/nexcare/grochat/close/chatroom`, data, token);
const getDataHistoryChat = (id, token) => Get(`/v1/nexcare/grochat/file/history?ticketId=${id}`, token);

const putDataDeleteTicket = (data, id, token) => Delete(`/${nexcareVersion}/nexcare/ticket/${id}`, data, token);

const getDataTicketInitiateLead = (token) => Get(`/${nexcareVersion}/nexcare/ticket/all/initiate?filter=is_closed eq false`, token);
const getDataTicketAllLead = (page, limit, orderBy, token) => Get(`/${nexcareVersion}/nexcare/ticket/all?page=${page}&limit=${limit}&order=${orderBy}&filter=is_closed eq false`, token);
const getDetailDataTicketAllNonCSO = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/${id}`, token);

const getListUserCustomerServiceTicketNew = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/tiket-masuk/user-cs?page=${page}&limit=${limit}`, token);
const getDataTicketInitiateAssignedUnassigned = (token) => Get(`/${nexcareVersion}/nexcare/ticket/all/assigned-unassign/initiate`, token);
const getDataTicketAssignedUnassigned = (page, limit, orderBy, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/assigned-unassign?page=${page}&limit=${limit}&order=${orderBy}`, token);
const getDetailTicketAssignedUnassigned = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/assigned-unassign/${id}`, token);

const getDataRelatedTicketAllCSOInitate = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/distributor/${id}/initiate`, token);
const getDataRelatedTicketAllCSO = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/ticket/distributor/${id}?page=${page}&limit=${limit}&order=id desc`, token);
const getDataRelatedTicketAllNonCSOInitate = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/distributor/${id}/initiate`, token);
const getDataRelatedTicketAllNonCSO = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/distributor/${id}?page=${page}&limit=${limit}&order=id desc`, token);

const getDataRelatedTicketNewInitate = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/assigned-unassign/distributor/${id}/initiate`, token);
const getDataRelatedTicketNew = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/assigned-unassign/distributor/${id}?page=${page}&limit=${limit}&order=id desc`, token);

const getDataRelatedTicketMemberInitate = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/member/distributor/${id}/initiate`, token);
const getDataRelatedTicketMember = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/member/distributor/${id}?page=${page}&limit=${limit}&order=id desc`, token);

const getDataRelatedTicketSolutionInitate = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/resolved/distributor/${id}/initiate`, token);
const getDataRelatedTicketSolution = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/ticket/resolved/distributor/${id}?page=${page}&limit=${limit}&order=id desc`, token);

const getDataDetailNoteAllNonCSO = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/notes/${id}?page=1&limit=10`, token);
const getDataDetailNoteAllCSO = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/notes/${id}?page=1&limit=10`, token);
const getDataDetailNoteNew = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/assigned-unassign/notes/${id}?page=1&limit=10`, token);
const getDataDetailNoteMember = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/member/notes/${id}?page=1&limit=10`, token);
const getDataDetailNoteSolution = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/resolved/notes/${id}?page=1&limit=10`, token);

const getDataTicketInitiateMember = (token) => Get(`/${nexcareVersion}/nexcare/ticket/all/member/initiate?filter=is_closed eq false`, token);
const getDataTicketMember = (page, limit, orderBy, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/member?page=${page}&limit=${limit}&order=${orderBy}&filter=is_closed eq false`, token);
const getDetailTicketMember = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/member/${id}`, token);

const getDataTicketAllLeadFilterInitiate = (filter, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/initiate${filter}`, token);
const getDataTicketAllLeadFilter = (page, limit, filter, orderBy, token) => Get(`/${nexcareVersion}/nexcare/ticket/all?page=${page}&limit=${limit}${filter}&order=${orderBy}`, token);

const getDataTicketMemberFilterInitiate = (filter, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/member/initiate${filter}`, token);
const getDataTicketMemberFilter = (page, limit, filter, orderBy, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/member?page=${page}&limit=${limit}${filter}&order=${orderBy}`, token);

const putDataUpdateCustomerName = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/update-customer-name/${id}`, data, token);

const getListAttachmentTicketNonCSO = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/ticket-attachment?page=1&limit=10&filter=ticket_id eq ${id}`, token);
const getListAttachmentTicketCSO = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/ticket-attachment?page=1&limit=10&filter=ticket_id eq ${id}`, token);
const getListAttachmentTicketNew = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/assigned-unassign/ticket-attachment?page=1&limit=10&filter=ticket_id eq ${id}`, token);
const getListAttachmentTicketMember = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/all/member/ticket-attachment?page=1&limit=10&filter=ticket_id eq ${id}`, token);
const getListAttachmentTicketSolution = (id, token) => Get(`/${nexcareVersion}/nexcare/ticket/resolved/ticket-attachment?page=1&limit=10&filter=ticket_id eq ${id}`, token);

const getListShift = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/tiket-masuk/list-shift-active?page=${page}&limit=${limit}`, token);
const getListUserCustomerService = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/user-cs?page=${page}&limit=${limit}&shiftArr=${id}&order=alias_name asc`, token);

const getListDistributor = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket-all/user-customer/distributor?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc`, token);
const getSearchDistributor = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/ticket-all/user-customer/distributor?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc`, token);

const getListPrincipal = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/ticket-all/user-customer/pic-principal?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc&distributor_id=${id}`, token);
const getSearchPrincipal = (page, limit, filter, id, token) => Get(`/${nexcareVersion}/nexcare/ticket-all/user-customer/pic-principal?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc&distributor_id=${id}`, token);

// Parameter Grab Ticket Timeout
const getParameterGrabTicketTimeout = (token) => Get(`/${nexcareVersion}/nexcare/ticket/unassigned/parameter/grab-ticket-timeout`, token);

// Default Open Room Chat
const getDefaultMessageRoomChat = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket/remark/default-message?page=${page}&limit=${limit}&filter=remark.remark eq default-message-escalate`, token);

// Escalation Ticket
const getListEscalation = (escalationType, page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket/remark/${escalationType}?page=${page}&limit=${limit}`, token);

// Closed Ticket
const getListClosedTicket = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/ticket/remark/closed-ticket?page=${page}&limit=${limit}`, token);

const API_TICKET_LIST = {
    getListRootCauseTicketAll,
    getListPriorityTicketAll,
    getListUserCSTicketAll,
    getSearchUserCSTicketAll,
    getDataTicketInitiateUnassigned,
    getDataTicketUnassigned,
    getDetailTicketUnassigned,
    getDataTicketInitiate,
    getDataTicketAll,
    getDataTicketEmail,
    getDataTicketPhone,
    getDetailDataTicketAllCSO,
    getListCustomerServiceLead,
    putDataOpenTicket,
    putDataAssignOwn,
    putDataAssignByLead,
    putDataReassignByLead,
    putDataReassignInProgress,
    putDataReopenTicket,
    putDataUpdateNote,
    putDataUpdateDescription,
    putDataUpdateTitle,
    putDataEscalationCsBySystem,
    putDataEscalationCsByUser,
    putDataEscalationBugExternal,
    putDataEscalationBugValidator,
    putDataEscalationLead,
    putDataUrlLink,
    putDataReleaseVersion,
    putDataRedmine,
    getListComplaint,
    getListComplaintCategory,
    getListComplaintSub,
    putDataTicketComplaint,
    putDataTicketRootCause,
    putDataCloseTicketWithPatch,
    putDataCloseTicketWithoutPatch,
    putDataCloseTicketWithoutSolution,
    putDataCloseTicketWorkAround,
    putDataCloseTicketChangeRequest,
    postDataUploadChat,
    putOpenChatroom,
    postCloseChatroom,
    getDataHistoryChat,
    putDataDeleteTicket,
    getDataTicketInitiateLead,
    getDataTicketAllLead,
    getDetailDataTicketAllNonCSO,
    getListUserCustomerServiceTicketNew,
    getDataTicketInitiateAssignedUnassigned,
    getDataTicketAssignedUnassigned,
    getDataRelatedTicketAllCSOInitate,
    getDataRelatedTicketAllCSO,
    getDetailTicketAssignedUnassigned,
    getDataRelatedTicketAllNonCSOInitate,
    getDataRelatedTicketAllNonCSO,
    getDataRelatedTicketNewInitate,
    getDataRelatedTicketNew,
    getDataRelatedTicketMemberInitate,
    getDataRelatedTicketMember,
    getDataRelatedTicketSolutionInitate,
    getDataRelatedTicketSolution,
    getDataDetailNoteAllNonCSO,
    getDataDetailNoteAllCSO,
    getDataDetailNoteNew,
    getDataDetailNoteMember,
    getDataDetailNoteSolution,
    getDataTicketInitiateMember,
    getDataTicketMember,
    getDetailTicketMember,
    getDataTicketAllLeadFilterInitiate,
    getDataTicketAllLeadFilter,
    getDataTicketMemberFilterInitiate,
    getDataTicketMemberFilter,
    putDataUpdateCustomerName,
    getListAttachmentTicketNonCSO,
    getListAttachmentTicketCSO,
    getListAttachmentTicketNew,
    getListAttachmentTicketMember,
    getListAttachmentTicketSolution,
    getListShift,
    getListUserCustomerService,
    getListDistributor,
    getSearchDistributor,
    getListPrincipal,
    getSearchPrincipal,
    getParameterGrabTicketTimeout,
    getDefaultMessageRoomChat,
    getListEscalation,
    getListClosedTicket
}

export default API_TICKET_LIST;